import { render, staticRenderFns } from "./ModalUser.vue?vue&type=template&id=640db9e7&scoped=true"
import script from "./ModalUser.vue?vue&type=script&lang=js"
export * from "./ModalUser.vue?vue&type=script&lang=js"
import style0 from "./ModalUser.vue?vue&type=style&index=0&id=640db9e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640db9e7",
  null
  
)

export default component.exports